import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f38e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-grid" }
const _hoisted_2 = { class: "range-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-separator" }, "至", -1))
const _hoisted_4 = { class: "range-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-separator" }, "-", -1))
const _hoisted_6 = { class: "range-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-separator" }, "-", -1))
const _hoisted_8 = { style: {"display":"flex"} }
const _hoisted_9 = { class: "goods-info-box" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "goods-image goods-image-empty"
}
const _hoisted_12 = { class: "goods-text-box" }
const _hoisted_13 = { class: "goods-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_GroupSelect = _resolveComponent("GroupSelect")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_SimpleSkuDetail = _resolveComponent("SimpleSkuDetail")!
  const _component_ui_popover = _resolveComponent("ui-popover")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_click_outside = _resolveDirective("click-outside")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "商品列表" }, {
            right: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.operatGoods()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 发布商品 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            class: "search-box",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_form_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.condition.startTime,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.condition.startTime) = $event)),
                        type: "datetime",
                        placeholder: "开始日期"
                      }, null, 8, ["modelValue"]),
                      _hoisted_3,
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.condition.endTime,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.condition.endTime) = $event)),
                        type: "datetime",
                        placeholder: "结束日期"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "商品名称" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _ctx.condition.name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.condition.name) = $event)),
                      placeholder: "输入商品名称"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "商品分组" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_GroupSelect, {
                      modelValue: _ctx.condition.categoryId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.condition.categoryId) = $event)),
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "销量" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.condition.sellMin,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.condition.sellMin) = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_5,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.condition.sellMax,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.condition.sellMax) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "价格" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.condition.priceMin,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.condition.priceMin) = $event))
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_7,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.condition.priceMax,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.condition.priceMax) = $event))
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, {
                label: "",
                style: {"margin-bottom":"0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.find())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("筛选")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      style: {"margin":"0 0 0 10px"},
                      onClick: _ctx.resetFilter,
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置筛选条件")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ui_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            "model-value": _ctx.condition.type,
            "onUpdate:modelValue": _ctx.tableChange,
            type: "card",
            class: "tabbar-box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "全部",
                name: "0"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "销售中",
                name: "1"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "已售罄",
                name: "2"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "下架",
                name: "3"
              })
            ]),
            _: 1
          }, 8, ["model-value", "onUpdate:modelValue"]),
          _withDirectives((_openBlock(), _createBlock(_component_ui_table, {
            data: _ctx.source.list
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "商品",
                "min-width": "260"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.goodsImage(row))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "goods-image",
                          src: _ctx.goodsImage(row)
                        }, null, 8, _hoisted_10))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, "无图")),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(row.name), 1),
                      _createVNode(_component_el_link, {
                        type: "primary",
                        onClick: ($event: any) => (_ctx.editName(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "价格(元)",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_ui_popover, {
                    width: "500",
                    trigger: "click"
                  }, {
                    default: _withCtx(({ hideEvent }) => [
                      _createVNode(_component_SimpleSkuDetail, {
                        modelValue: row,
                        hideEvent: hideEvent,
                        onRefresh: _ctx.refresh
                      }, null, 8, ["modelValue", "hideEvent", "onRefresh"])
                    ]),
                    reference: _withCtx(({ showEvent, hideEvent }) => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                        type: "primary",
                        title: "点击修改价格",
                        onClick: showEvent
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.showPrice), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_click_outside, hideEvent]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "库存",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_ui_popover, {
                    width: "500",
                    trigger: "click"
                  }, {
                    default: _withCtx(({ hideEvent }) => [
                      _createVNode(_component_SimpleSkuDetail, {
                        modelValue: row,
                        hideEvent: hideEvent,
                        onRefresh: _ctx.refresh
                      }, null, 8, ["modelValue", "hideEvent", "onRefresh"])
                    ]),
                    reference: _withCtx(({ showEvent, hideEvent }) => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                        type: "primary",
                        title: "点击修改库存",
                        onClick: showEvent
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.stock), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_click_outside, hideEvent]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "销量",
                prop: "buyNumOrigin"
              }),
              _createVNode(_component_el_table_column, {
                label: "排序",
                prop: "sort",
                width: "80"
              }),
              _createVNode(_component_el_table_column, { label: "创建时间" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.$format(row.createTime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "260",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_ui_button, {
                    onClick: ($event: any) => (_ctx.operatGoods(row.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("修改")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_ui_button, {
                    onClick: ($event: any) => (_ctx.cloneGoods(row.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("复制商品")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_popconfirm, {
                    title: "是否删除该记录",
                    onConfirm: ($event: any) => (_ctx.deleteRow(row.id)),
                    style: {"margin-left":"10px"}
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_ui_button, { type: "danger" }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.source.loading]
          ]),
          _createVNode(_component_ui_page, {
            modelValue: _ctx.page.page,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.page.page) = $event)),
            info: _ctx.pageInfo
          }, null, 8, ["modelValue", "info"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}